import React                    from 'react';
import { Observe }              from 'rewire-core';
import { WithStyle }            from 'rewire-ui';
import { withStyles }           from '../utility/styles';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import auditLogDialogModel      from './AuditLogDialogModel';
import auditLogListModel        from './AuditLogListModel';
import AuditLogListView         from './AuditLogListView';
import AuditLogItemView         from './AuditLogItemView';
import AuditLogListToolbar      from './AuditLogListToolbar';
import Typography               from '@material-ui/core/Typography';

const styles = (_theme: Theme) => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    width: '100%',
    padding: '0px 15px',
    overflow: 'hidden',
  },
  innerContentContainer: {
    display: 'flex',
    flex: '1',
    width: '100%',
    overflow: 'hidden',
    gap: '12px',
  },
  noEntries: {
    margin: 'auto',
  },
  toolbarRoot: {
    position: 'absolute',
    right: '15px',
    top: '8px',
  },
});

export interface IAuditLogDialogProps {
}

export type AuditLogDialogProps = WithStyle<ReturnType<typeof styles>, IAuditLogDialogProps>;

class AuditLogDialog extends React.PureComponent<AuditLogDialogProps> {
  constructor(props: AuditLogDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    auditLogDialogModel.reset();
    auditLogDialogModel.close();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <div className={this.props.classes.contentContainer}>
        <AuditLogListToolbar classes={{root: this.props.classes.toolbarRoot}}/>
        {!auditLogListModel.auditLogCount
          ? <Typography variant='h3' className={this.props.classes.noEntries}>No Audit Log Entries</Typography>
          : <div className={this.props.classes.innerContentContainer}>
              <AuditLogListView />
              <AuditLogItemView />
            </div>
        }
      </div> 
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='md' defaultHeight='800px' DialogProps={{dialog: auditLogDialogModel}} DraggableResizableBoxProps={{minWidth: '1024px', minHeight: '700px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAuditLogDialogProps>(styles, AuditLogDialog);
